
import LazyProductCarousel from 'Src/js/components/carousels/LazyProductCarousel.vue';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Get } from 'vuex-pathify';
import { IPdpProductCarousels } from 'JS/types/PDP';

@Component({
	name: 'PageBottomCarouselApp',
	components: {
		LazyProductCarousel,
	},
})
class PageBottomCarouselApp extends Vue {
	@Get('carousels')
	carousels: IPdpProductCarousels;
}

export default PageBottomCarouselApp;
